import { avatarClasses } from '@mui/material/Avatar';
import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiCardHeader = {
  defaultProps: {
    titleTypographyProps: { variant: 'subtitle1' },
    subheaderTypographyProps: { variant: 'body2' },
  },
  styleOverrides: {
    root: { padding: '24px 24px 0' },
    avatar: {
      [`& .${avatarClasses.root}`]: {
        '--Icon-fontSize': 'var(--icon-fontSize-lg)',
        '--Avatar-size': '36px',
        backgroundColor: 'var(--mui-palette-background-level1)',
        border: '1px solid var(--mui-palette-divider)',
        boxShadow: 'none',
        color: 'var(--mui-palette-text-secondary)',
      },
    },
  },
} satisfies Components<Theme>['MuiCardHeader'];
